import { AsyncPipe, CommonModule } from "@angular/common";
import { NgModule, inject } from "@angular/core";

import { svgCross, SvgRegistryService } from "@hermes/aphrodite-svg";
import {
    FooterComponent,
    FooterLightComponent,
} from "@hermes/domains-shell-fragments-footer";

import { FooterDeprecatedModule } from "@hermes/domains-shell-fragments-footer-deprecated";
import { HeaderModule } from "@hermes/domains-shell-fragments-header";
import { ShellStateModule } from "@hermes/domains-shell-states-shell-state";
import { GeoFilteringTrayModule } from "@hermes/domains-shell-trays-geofiltering-tray";
import { TrayStateModule } from "@hermes/hermes-web-states-tray-state";
import { UserStateModule } from "@hermes/hermes-web-states-user-state";
import { RouterServiceModule } from "@hermes/utils-generic-services-router";

import { NotificationModalComponent } from "./components/notification";
import { ShellComponent } from "./components/shell/shell.component";

@NgModule({
    imports: [
        CommonModule,
        FooterDeprecatedModule,
        HeaderModule,
        RouterServiceModule,
        TrayStateModule,
        UserStateModule,
        ShellStateModule,
        NotificationModalComponent,
        GeoFilteringTrayModule,
        FooterComponent,
        AsyncPipe,
        ShellComponent,
        FooterLightComponent,
    ],
    exports: [ShellComponent],
})
export class ShellModule {
    constructor() {
        const svgRegistryService = inject(SvgRegistryService);

        svgRegistryService.registerSvgs([svgCross]);
    }
}
